import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FlexLayoutModule } from '@ngbracket/ngx-layout'

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [CommonModule, FlexLayoutModule],
  template: `
    <ng-container [ngSwitch]="variant">
      <div *ngSwitchCase="'default'" fxLayoutAlign="space-between center">
        <h1>{{ title }}</h1>
        <div fxLayout="row wrap" fxLayoutGap="8px"><ng-container *ngTemplateOutlet="content"></ng-container></div>
      </div>
      <div *ngSwitchCase="'responsive-md'" fxLayoutAlign.gt-md="space-between center">
        <h1>{{ title }}</h1>
        <div fxLayout="row wrap" fxLayoutGap="8px"><ng-container *ngTemplateOutlet="content"></ng-container></div>
      </div>
      <div *ngSwitchCase="'responsive-xs'" fxLayoutAlign.gt-xs="space-between center">
        <h1>{{ title }}</h1>
        <div fxLayout="row wrap" fxLayoutGap="8px"><ng-container *ngTemplateOutlet="content"></ng-container></div>
      </div>
      <h1 *ngSwitchCase="'title-only'">{{ title }}</h1>
    </ng-container>
    <ng-template #content><ng-content></ng-content></ng-template>
  `
})
export class PageHeaderComponent {
  @Input() title = ''
  @Input() variant: 'default' | 'responsive-md' | 'responsive-xs' | 'title-only' = 'default'
}
